import Axios from "axios";
import { homeDataConstants } from "../constants/HomeDataConstants";

import { setTokens } from "../helpers/auth-header";
import { authHeader } from "../helpers/auth-header";
import { userService } from '../services/UserService';
var url = process.env.REACT_APP_URL || "http://localhost:8080/";

export const homeDataService = {

	getDemoVideo,
	getDemoVideoVideo,
	getPremadeVideo,
	updateApi,
	getVideosForLibrary,
	pay,
	getFamousPeople,
	getStory,
	generatepois,
	generateaddposts,
	createTour,
	getTourLibrary,
	generatePaymentLink,
	saveTourName,
	prompts


};

async function saveTourName(dispatch, tourName) {


	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	Axios.get(`${url}api/pnl/tour/videotour/tourname/` + tourName,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {

				//window.location.href = "/#/storyvideogeneration"
				dispatch(success(res.data));

			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_TOUR_NAME_REQUEST };
	}
	function success(data) {
		console.log(data)

		return { type: homeDataConstants.GET_TOUR_NAME_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_TOUR_NAME_FAILURE, error };
	}
}



async function prompts(dispatch, data) {

	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	//https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app
	   // const response = await fetch(`http://localhost:5000/update_scraped`, { 
	await Axios.post(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/prompt_adjustment`, data,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_PROMPT_REQUEST };
	}
	function success(data) {
	
		return { type: homeDataConstants.GET_PROMPT_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_PROMPT_FAILURE, error };
	}
}

async function generateaddposts(dispatch, data) {

	var tour = data.tour
	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	//https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app
	await Axios.post(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/generate_adds`, data,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_ADDS_REQUEST };
	}
	function success(data) {
		console.log(data)
		var data1={
			tour: tour,
			ads:data
		}
		updateAds(dispatch, data1)
		return { type: homeDataConstants.GET_ADDS_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_ADDS_FAILURE, error };
	}
}


async function generatepois(dispatch, data) {

	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	Axios.post(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/points_of_interest`, data,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_POIS_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: homeDataConstants.GET_POIS_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_POIS_FAILURE, error };
	}
}




async function getFamousPeople(dispatch, data) {

	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	Axios.post(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/city_audience`, data,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_FAMOUS_PEOPLE_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: homeDataConstants.GET_FAMOUS_PEOPLE_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_FAMOUS_PEOPLE_FAILURE, error };
	}
}

async function getStory(dispatch, data, tourName) {
	var tourName = tourName;
  
	dispatch(request());
  
	var token = authHeader();
	try {
	  const res = await Axios.post(`https://hopguides-chatgpt-main-j7limbsbmq-oc.a.run.app/story`, data, {
		headers: {
		  Authorization: token
		}
	  }, { validateStatus: () => true });
  
	  if (res.status === 200) {
		dispatch(success(res.data));
		return res.data; // Return the data here
	  } else if (res.status === 215) {
		dispatch(failure(res.data.response));
	  } else if (res.status === 402) {
		dispatch(failure("Error"));
	  } else {
		dispatch(failure("Error"));
	  }
	} catch (err) {
	  dispatch(failure(err));
	  throw err; // Rethrow the error to handle it in the calling function
	}
  
	function request() {
	  return { type: homeDataConstants.GET_STORY_REQUEST };
	}
  
	function success(data) {
	  console.log(data);
	  return { type: homeDataConstants.GET_STORY_SUCCESS, data };
	}
  
	function failure(error) {
	  console.log(error);
	  return { type: homeDataConstants.GET_STORY_FAILURE, error };
	}
  }

async function createTour(dispatch, data, tourName) {


	console.log(data)
	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	Axios.post(`${url}api/pnl/tour/videotour/create/` + tourName, data,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {

				//window.location.href = "/#/storyvideogeneration"
				dispatch(success(res.data));

			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_CREATE_TOUR_VIDEO_REQUEST };
	}
	function success(data) {
		console.log(data)

		return { type: homeDataConstants.GET_CREATE_TOUR_VIDEO_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_CREATE_TOUR_VIDEO_FAILURE, error };
	}
}


async function getVideosForLibrary(dispatch) {

	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	Axios.get(`${url}api/pnl/tour/getlibrary/videos`,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_VIDEOS_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: homeDataConstants.GET_VIDEOS_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_VIDEOS_FAILURE, error };
	}
}



async function pay(dispatch, body) {

	dispatch(request());

	var token = authHeader()
	//var token = authHeader()
	Axios.post(`${url}api/pnl/tour/stripe/pay`, body,
		{
			headers: {
				Authorization: token
			}
		}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				window.location = res.data.url
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("Error"));

			} else {

				dispatch(failure("Error"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.GET_VIDEOS_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: homeDataConstants.GET_VIDEOS_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.GET_VIDEOS_FAILURE, error };
	}
}
async function updateApi(dispatch, api) {

	dispatch(request());

	var token = authHeader()
	Axios.get(`${url}api/pnl/tour/d-id/api/${api}`, {
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then(async (res) => {
			if (res.status === 200) {

				await userService.getPaid(dispatch);
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("You do not have eough tokens on d-id. Generate new api."));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.CHANGE_API_REQUEST };
	}
	function success(data) {
		return { type: homeDataConstants.CHANGE_API_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		return { type: homeDataConstants.CHANGE_API_FAILURE, error };
	}
}

async function getPremadeVideo(dispatch, data, tokens) {


	dispatch(request());

	var token = authHeader()
	Axios.post(`${url}api/pnl/tour/d-id/premade`, data, {
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {

				console.log(tokens)
				setTokens(res.data.tokens);
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure("You do not have enough tokens on d-id. Generate new api."));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			if (err.status === 215) {
				dispatch(failure(err.data.response));
			}
			else if (err.status === 402) {
				dispatch(failure("You do not have enough tokens on d-id. Generate new api."));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
			dispatch(failure(err));
		})

	function request() {

		return { type: homeDataConstants.SEND_DEMO_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: homeDataConstants.SEND_DEMO_SUCCESS, data };
	}
	function failure(error) {
		console.log("error")
		//console.log(error)
		return { type: homeDataConstants.SEND_DEMO_FAILURE, data: "You don't have enough tokens" };
	}
}




async function updateChapter(dispatch, data, video) {

	var data1 = {
		data : data,
		video: video
	}
	dispatch(request());

	var token = authHeader()
	Axios.post(`${url}api/pnl/tour/videotour/update`, data1, {
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure(res.data.message));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			if (err.response && err.response.status === 215) {
			  dispatch(failure(err.response.data.response));
			}
			else if (err.response && err.response.status === 402) {
			  dispatch(failure(err.response.data.message));
			} else {
			  dispatch(failure(err.message));
			}
		  })

	function request() {

		return { type: homeDataConstants.GET_CREATE_TOUR_VIDEO_REQUEST };
	}
	function success(data) {
		console.log(data)

		return { type: homeDataConstants.GET_CREATE_TOUR_VIDEO_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		//console.log(error)
		return { type: homeDataConstants.GET_CREATE_TOUR_VIDEO_FAILURE, data: error };
	}
}




async function updateAds(dispatch, data) {


	dispatch(request());

	var token = authHeader()
	Axios.post(`${url}api/pnl/tour/videotour/ads`, data, {
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				dispatch(failure(res.data.message));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			if (err.response && err.response.status === 215) {
			  dispatch(failure(err.response.data.response));
			}
			else if (err.response && err.response.status === 402) {
			  dispatch(failure(err.response.data.message));
			} else {
			  dispatch(failure(err.message));
			}
		  })

	function request() {

		return { type: homeDataConstants.UPDATE_ADDS_REQUEST };
	}
	function success(data) {
		console.log(data)

		return { type: homeDataConstants.UPDATE_ADDS_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		//console.log(error)
		return { type: homeDataConstants.UPDATE_ADDS_FAILURE, data: error };
	}
}





async function getDemoVideo(dispatch, data, tokens) {

	var data = data

	dispatch(request());

	var token = authHeader()
	await Axios.post(`${url}api/pnl/tour/d-id/generate`, data, {
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {

				console.log(tokens)
				console.log(data)
				setTokens(res.data.tokens);
				dispatch(success(res.data, data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				console.log(res)
				dispatch(failure(res.data.message));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			if (err.response && err.response.status === 215) {
			  dispatch(failure(err.response.data.response));
			}
			else if (err.response && err.response.status === 402) {
			  dispatch(failure(err.response.data.message));
			} else {
			  dispatch(failure(err.message));
			}
		  })

	function request() {

		return { type: homeDataConstants.SEND_DEMO_REQUEST };
	}
	function success(data, data1) {
		console.log(data)
		updateChapter(dispatch, data1, data.data)

		return { type: homeDataConstants.SEND_DEMO_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		//console.log(error)
		return { type: homeDataConstants.SEND_DEMO_FAILURE, data: error };
	}
}


async function getDemoVideoVideo(dispatch, data, tokens) {

	var data = data

	dispatch(request());

	var token = authHeader()
	await Axios.post(`${url}api/pnl/tour/d-id/generate`, data, {
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {

				console.log(tokens)
				console.log(data)
				setTokens(res.data.tokens);
				dispatch(success(res.data, data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				console.log(res)
				dispatch(failure(res.data.message));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			if (err.response && err.response.status === 215) {
			  dispatch(failure(err.response.data.response));
			}
			else if (err.response && err.response.status === 402) {
			  dispatch(failure(err.response.data.message));
			} else {
			  dispatch(failure(err.message));
			}
		  })

	function request() {

		return { type: homeDataConstants.SEND_DEMO_REQUEST };
	}
	function success(data, data1) {

		return { type: homeDataConstants.SEND_DEMO_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		//console.log(error)
		return { type: homeDataConstants.SEND_DEMO_FAILURE, data: error };
	}
}



async function getTourLibrary(dispatch) {


	dispatch(request());

	var token = authHeader()
	Axios.get(`${url}api/pnl/tour/videotour/getAll`, {
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {

				
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				console.log(res)
				dispatch(failure(res.data.message));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			if (err.response && err.response.status === 215) {
			  dispatch(failure(err.response.data.response));
			}
			else if (err.response && err.response.status === 402) {
			  dispatch(failure(err.response.data.message));
			} else {
			  dispatch(failure(err.message));
			}
		  })

	function request() {

		return { type: homeDataConstants.GET_TOUR_LIBRARY_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: homeDataConstants.GET_TOUR_LIBRARY_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		//console.log(error)
		return { type: homeDataConstants.GET_TOUR_LIBRARY_FAILURE, data: error };
	}
}



async function generatePaymentLink(dispatch, tourId) {


	console.log(tourId)
	var body={
		tourId: tourId
	}
	dispatch(request());

	var token = authHeader()
	Axios.post(`${url}api/pnl/tour/stripe/customizedPayment`, body,{
		headers: {
			Authorization: token
		}
	}, { validateStatus: () => true })
		.then((res) => {
			if (res.status === 200) {

				
				dispatch(success(res.data));
			} else if (res.status === 215) {
				dispatch(failure(res.data.response));
			}
			else if (res.status === 402) {
				console.log(res)
				dispatch(failure(res.data.message));

			} else {

				dispatch(failure("You don't have enough tokens"));
			}
		})
		.catch((err) => {
			if (err.response && err.response.status === 215) {
			  dispatch(failure(err.response.data.response));
			}
			else if (err.response && err.response.status === 402) {
			  dispatch(failure(err.response.data.message));
			} else {
			  dispatch(failure(err.message));
			}
		  })

	function request() {

		return { type: homeDataConstants.GET_PATMENT_LINK_REQUEST };
	}
	function success(data) {
		console.log(data)
		return { type: homeDataConstants.GET_PATMENT_LINK_SUCCESS, data };
	}
	function failure(error) {
		console.log(error)
		//console.log(error)
		return { type: homeDataConstants.GET_PATMENT_LINK_FAILURE, data: error };
	}
}


